module.exports = "/images/vendor/flag-icon-css/flags/1x1/ci.svg?26a62321690cd175f47305c05a55f409";